import { Avatar, Box, Flex, IconButton, IconChevronLeft, IconMenu } from "@myphx-engineering/phx-design-system";
import { getInitials } from "@myphx-engineering/phx-design-system/framework";
import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";

//#region src/components/navigation-bar/NavigationBar.tsx
const NavigationBar = ({ username, auth, onAvatarClick, onLogoClick, onBackButtonClick }) => {
	const showBackButton = !!onBackButtonClick;
	const showAvatar = !!onAvatarClick;
	const initials = useMemo(() => {
		if (!auth) return;
		if (username) return getInitials(username);
	}, [auth, username]);
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		align: "center",
		p: "xxs",
		style: { width: "100%" },
		children: [
			/* @__PURE__ */ jsx(Box, { children: showBackButton ? /* @__PURE__ */ jsx(IconButton, {
				Icon: IconChevronLeft,
				size: "sm",
				onClick: onBackButtonClick,
				color: "primary",
				disabled: false
			}) : null }),
			/* @__PURE__ */ jsx("img", {
				src: "/static/libraries/myphx-lib/application-header/myprescryptive-logo.png",
				style: {
					width: "128px",
					height: "48px",
					cursor: onLogoClick ? "pointer" : "initial"
				},
				alt: "myprescryptive-logo",
				onClick: onLogoClick
			}),
			/* @__PURE__ */ jsx(Box, { children: showAvatar ? /* @__PURE__ */ jsx(Avatar, {
				onClick: onAvatarClick,
				size: "md",
				initials,
				AvatarIcon: initials ? void 0 : IconMenu,
				color: "primary"
			}) : null })
		]
	});
};

//#endregion
export { NavigationBar };